"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _getUniqueId = require("../utils/getUniqueId");

var _context = require("../context");

var _helpers = require("../helpers");

var _layout = require("../layout");

var _ExpanderContent = _interopRequireDefault(require("./ExpanderContent"));

var _constants = require("./constants");

var _defaultTitleRenderer = require("./defaultTitleRenderer");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ExpanderWithoutDocs = function ExpanderWithoutDocs(_ref) {
  var children = _ref.children,
      titleText = _ref.titleText,
      _ref$renderTitle = _ref.renderTitle,
      renderTitle = _ref$renderTitle === void 0 ? _defaultTitleRenderer.defaultTitleRenderer : _ref$renderTitle,
      isExpandedProp = _ref.isExpanded,
      onToggle = _ref.onToggle,
      _ref$chevronPosition = _ref.chevronPosition,
      chevronPosition = _ref$chevronPosition === void 0 ? _constants.ExpanderDefaultProps.chevronPosition : _ref$chevronPosition,
      _ref$shouldExpandOnMo = _ref.shouldExpandOnMount,
      shouldExpandOnMount = _ref$shouldExpandOnMo === void 0 ? _constants.ExpanderDefaultProps.shouldExpandOnMount : _ref$shouldExpandOnMo,
      _ref$contentSpacing = _ref.contentSpacing,
      contentSpacing = _ref$contentSpacing === void 0 ? _constants.ExpanderDefaultProps.contentSpacing : _ref$contentSpacing,
      ariaDescribedby = _ref['aria-describedby'],
      dataTestId = _ref.dataTestId;

  var _useState = (0, _react.useState)((0, _getUniqueId.getUniqueId)()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      idNumber = _useState2[0];

  var _useState3 = (0, _react.useState)(shouldExpandOnMount),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isExpandedState = _useState4[0],
      setIsExpandedState = _useState4[1];

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var expanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedState;

  var toggle = function toggle() {
    setIsExpandedState(!expanded);
    !!onToggle && onToggle(!expanded);
  };

  var topSpacing = typeof contentSpacing === 'number' ? contentSpacing : selectors.space(contentSpacing) || 0;
  var dataTestProps = {
    'data-test-component': 'StencilExpander',
    'data-test-id': dataTestId
  };
  var id = "StencilExpander-".concat(idNumber);
  var chevron = (0, _core.jsx)(_helpers.TriggerButton, {
    isExpanded: expanded,
    onClick: toggle,
    iconAltText: titleText,
    "aria-describedby": ariaDescribedby
  });
  return (0, _core.jsx)(_layout.Col, dataTestProps, (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: "S200"
  }, chevronPosition === _interfaces.ExpanderChevronPosition.Leading && chevron, (0, _core.jsx)(_layout.Row, {
    id: id,
    "data-test-component": "StencilExpanderTitle",
    flex: 1
  }, renderTitle({
    titleText: titleText,
    toggle: toggle
  })), chevronPosition === _interfaces.ExpanderChevronPosition.Trailing && chevron), (0, _core.jsx)(_ExpanderContent.default, {
    isExpanded: expanded,
    topSpacing: topSpacing
  }, children));
};

ExpanderWithoutDocs.defaultProps = _objectSpread({}, _constants.ExpanderDefaultProps);
var Expander = (0, _stencilReactDesc.describe)(ExpanderWithoutDocs).description('Container which shows and hides content, controlled by a trigger button.');
Expander.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the container.'),
  titleText: _stencilReactDesc.PropTypes.string.isRequired.description('Title to display above the expandable content.'),
  renderTitle: _stencilReactDesc.PropTypes.func.description('Customizes how the title is displayed.').format("({\n  titleText: string,\n  toggle: () => void\n}) => ReactNode"),
  isExpanded: _stencilReactDesc.PropTypes.bool.description('Overrides the state of the component to control whether it is expanded or collapsed.'),
  onToggle: _stencilReactDesc.PropTypes.func.description('Callback called when the trigger button is clicked. The argument will be the new state of the component.').format('(isExpanded: boolean) => void'),
  shouldExpandOnMount: _stencilReactDesc.PropTypes.bool.description('Whether the component should expand by default on first render.'),
  chevronPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ExpanderChevronPosition)).description('Customizes the position of the chevron.'),
  contentSpacing: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.number, _stencilReactDesc.PropTypes.string]).description('Spacing between the title and the expandable content.'),
  'aria-describedby': _stencilReactDesc.PropTypes.string.description("Sets the 'aria-describedby' attribute in the DOM for the trigger button. Generally, this prop SHOULD NOT be used. In Stencil it's used internally in the Select component with multi selection."),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
Expander.displayName = 'Expander';
var _default = Expander;
exports.default = _default;